import React, {useState} from 'react';
import './groupForm.css'
import {InputSaveEdit, SelectorSaveEdit} from "../../shared";
import auth from "../../../utils/authentication";
import ImageProfile from "../../profile/imageProfile/imageProfile";
import groupDefault from "../../../images/groupdefault.png";
import {getGroupPhotoUrl, isMobileDevice, uploadFile} from "../../../utils/utils";
import {FormattedMessage, useIntl} from "react-intl";
import {GROUP_HIDDEN, GROUP_PRIVATE, GROUP_PUBLIC, MAX_CATEGORIES_NB} from "../../../utils/consts";
import functions from "../../../utils/functionsFirebase";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {addNewGroup} from '../actions'

function GroupForm({inputGroup, setInputGroup, onSave}) {

    const intl = useIntl();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [cropImage, setCropImage] = useState(null);
    const [group, setGroup] = useState(inputGroup ?? {})
    let [category, setCategory] = useState("")
    const [categories, setCategories] = useState(group.categories ?? []);
    let [groupName, setGroupName] = useState(group.groupName ?? "");
    let [groupPrivacy, setGroupPrivacy] = useState(group.privacy);
    const [groupImage, setGroupImage] = useState(getGroupPhotoUrl(group) ?? groupDefault);
    const [isNew, setIsNew] = useState(inputGroup?.id == null);
    const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     if(inputGroup?.id){
    //         saveGroup();
    //     }
    // }, [categories.length, groupImage, groupPrivacy, groupName]);

    function addCategories() {
        if (category) {
            setCategories(prevState => {
                if (prevState.length >= MAX_CATEGORIES_NB) {
                    setCategory("");
                    return prevState;
                }
                let newCategories = category.split(' ').filter(x => x && !prevState.some(y => y === x));
                newCategories = newCategories.slice(0, Math.min(MAX_CATEGORIES_NB - prevState.length, newCategories.length))
                prevState.push(...newCategories);
                category = "";
                setCategory("");
                return prevState;
            });
        }
    }

    async function saveGroup() {
        setLoading(true);
        group.categories = categories;
        group.groupName = groupName;
        group.privacy = groupPrivacy;
        group.uidCreator = auth.currentUser.uid;
        if (!inputGroup) {
            group.joinedUsers = groupImage.joinedUsers ?? 1;
        }
        if (!group.photoUrl) {
            group.photoUrl = groupDefault;
        }
        const saveGroup = functions.httpsCallable("saveGroup");
        const response = await saveGroup({group});
        group.id = response.data.group.id;
        if (group.photoUrl !== groupImage) {
            //there is a new image. upload it
            group.photoUrl = await uploadFile(cropImage, `groupPictures/${auth.currentUser.uid}/${group.id}`);
        }
        const res = await saveGroup({group});
        setLoading(false);
        if (!inputGroup) {
            dispatch(addNewGroup(res.data.group))
            navigate('/groups/group-details/' + res.data.group.id);
        } else {
            setInputGroup(res.data.group);
        }
    }

    return (
        <div>
            <div className="col-12 d-flex flex-row flex-wrap">
                <div className={((isMobileDevice()) ? "col-12" : "col-6") + " mb-4"}>
                    <ImageProfile image={groupImage} handleProfilePictureUpload={(file) => {
                        setCropImage(file);
                        const urlBlob = URL.createObjectURL(file);
                        setGroupImage(urlBlob)
                        return urlBlob;
                    }}/>
                </div>
                <div className={((isMobileDevice()) ? "col-12" : "col-6") + " mb-4"}>
                    <InputSaveEdit alwaysEditing={true}
                                   id="groupNameInput"
                                   showLabel={true}
                                   label={intl.formatMessage({id: "groups.group-form.group-name"})}
                                   inputValue={groupName}
                                   maxLength={30}
                                   onSave={value => {
                                       setGroupName(value);
                                   }}/>
                    <div className="mb-4"></div>
                    <SelectorSaveEdit alwaysEditing={true} required={true}
                                      label={intl.formatMessage({id: "groups.group-form.privacy"})}
                                      inputLabel={intl.formatMessage({id: "groups.group-form.select-privacy"})}
                                      inputValue={groupPrivacy}
                                      options={[
                                          {
                                              code: GROUP_PRIVATE,
                                              label: intl.formatMessage({id: 'groups.privacy.private'})
                                          },
                                          {
                                              code: GROUP_PUBLIC,
                                              label: intl.formatMessage({id: 'groups.privacy.public'})
                                          },
                                          {code: GROUP_HIDDEN, label: intl.formatMessage({id: 'groups.privacy.hidden'})}
                                      ]}
                                      onSave={value => {
                                          setGroupPrivacy(value);
                                      }}
                    />
                </div>
            </div>
            <div className="col-12">

                <label style={{fontWeight: "bold"}} htmlFor="categoriesInput">
                    <FormattedMessage id="groups.group-form.categories"/> ({categories.length}/{MAX_CATEGORIES_NB})
                </label>
                <div className="col-12 d-flex flex-wrap">
                    <div className="input-group mb-1 col-12 ">
                        <input id="categoriesInput" value={category} onChange={e => {
                            if (e.nativeEvent.data === " ") {
                                addCategories();
                            } else {
                                setCategory(e.target.value);
                            }
                        }} onKeyDown={e => {
                            if (e.key === 'Enter') {
                                addCategories();
                            }
                        }}
                               autoComplete="false" type="text" className="form-control"
                               disabled={categories.length >= MAX_CATEGORIES_NB}/>
                        <span style={{width: '42px', cursor: 'pointer'}}
                              className="input-group-text d-flex justify-content-center button-edit"
                              onClick={() => addCategories()}>
                            <i className="fa-solid fa-plus"/>
                        </span>
                    </div>
                    <div id="validationSelector" className="invalid-feedback">
                        <FormattedMessage id="input-save-edit.invalid-feedback"/>
                    </div>
                </div>

            </div>
            <div className="col-12">
                {categories?.map((x, i) => {
                    return <span key={x} className="badge text-bg-secondary m-1">{x}
                        <i style={{cursor: "pointer"}} className="fa-solid fa-times ps-2"
                           onClick={() => {
                               // Crear una copia del array original
                               const newCategories = [...categories];
                               // Eliminar el elemento deseado usando filter
                               newCategories.splice(i, 1);
                               // Actualizar el estado con la nueva copia del array
                               setCategories(newCategories);
                           }}></i></span>
                })}
            </div>

            <div className="col-12 mt-5 d-flex flex-row justify-content-end">
                {isNew && <button className="btn btn-success" onClick={saveGroup}
                                  disabled={!groupName || !groupPrivacy || loading}>
                    <FormattedMessage id="groups.group-form.confirm-create"/>
                    {loading && <i className="fa-solid fa-circle-notch fa-spin ms-2"></i>}
                    {!loading && <i className="fa-solid fa-plus ms-2"></i>}
                </button>}
                {!isNew && <button className="btn btn-success" onClick={() => {
                    saveGroup();
                    onSave();
                }} disabled={!groupName || !groupPrivacy || loading}>
                    <FormattedMessage id="app.save-changes"/>
                    {loading && <i className="fa-solid fa-circle-notch fa-spin ms-2"></i>}
                    {!loading && <i className="fa-solid fa-floppy-disk ms-2"></i>}
                </button>}
            </div>
        </div>
    )
}

export default GroupForm;
